import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/rana-logo.png")